import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { Cart, CartLine } from '@msdyn365-commerce/retail-proxy';

export interface ICheckoutAppliedState {
    applied: {
        customerInformation: boolean;
        shippingInformation: boolean;
        deliveryOptions: boolean;
    },
    newCartObject: Partial<Cart>;
    newCartLinesObject: CartLine[];
}

export class CheckoutAppliedStateInput implements IActionInput {
    public getCacheKey = () => `CheckoutAppliedState`;
    public getCacheObjectType = () => 'CheckoutAppliedState';
    public dataCacheType = (): CacheType => 'request';
}

export async function checkoutAppliedStateAction(input: CheckoutAppliedStateInput, ctx: IActionContext): Promise<ICheckoutAppliedState> {
    return {
        applied: {
            customerInformation: false,
            shippingInformation: false,
            deliveryOptions: false
        },
        newCartObject: {},
        newCartLinesObject: []
    };
}

const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new CheckoutAppliedStateInput();
};

export default createObservableDataAction<ICheckoutAppliedState>({
    action: <IAction<ICheckoutAppliedState>>checkoutAppliedStateAction,
    input: createInput
});
